import React, { useContext } from "react";
import { RicosViewerContext } from "./../../ricos-context";
import { POLL_TYPE } from "../types";
import PollViewer from "./poll-viewer";
const Poll = ({ node, nodeIndex, NodeViewContainer }) => {
  const { config } = useContext(RicosViewerContext);
  return /* @__PURE__ */ React.createElement(NodeViewContainer, { node, nodeIndex }, /* @__PURE__ */ React.createElement(
    PollViewer,
    {
      componentData: node.pollData,
      settings: config[POLL_TYPE],
      isViewMode: true
    }
  ));
};
var poll_default = Poll;
export {
  poll_default as default
};
//# sourceMappingURL=poll.js.map

import "@wix/ricos/css/plugin-social-polls-viewer.global.css";